import { Icon, Input, type InputProps, Spinner } from '@sr/ui-library';

export interface AppSearchInputProps extends Pick<
  InputProps,
  'className' | 'classes' | 'disabled' | 'placeholder'
> {
  isFetching?: boolean;
  onChange: (value: string) => void;
  value: string;
}

/** Shared presentational search input (icon/spinner + clear button) used by MSR3 list pages. */
export const AppSearchInput = ({
  disabled,
  isFetching,
  onChange,
  value,
  ...inputProps
}: AppSearchInputProps) => (
  <Input
    {...inputProps}
    disabled={disabled}
    sectionLeft={isFetching ? <Spinner /> : <Icon icon="search" />}
    sectionRight={
      value && (
        <button
          aria-label="Clear search"
          disabled={disabled}
          type="button"
          onClick={() => onChange('')}
        >
          <Icon icon="close" size="sm" />
        </button>
      )
    }
    sectionRightPointer
    sectionRightPointerEvents
    value={value}
    onChange={(e) => onChange(e.target.value)}
  />
);
